import $ from 'jquery';
import * as Utils from 'lib/utils';

$.registerUI('tooltip', {
  init() {
    this.find('[data-tooltip]').each(function () {
      const $obj = $(this);
      const data = $obj.data();
      const color = data.color;
      const modal = data.in_modal || false;
      const arrow = Utils.toBoolean(data.arrow, true);
      const delayShow = Utils.toInt(data.delayShow, 300);
      const delayHide = Utils.toInt(data.delayHide, 300);

      let delay = Utils.toInt(data.delay, 300);
      if (data.delay === undefined) delay = { show: delayShow, hide: delayHide };

      $obj
        .tooltip({
          animation: Utils.toBoolean(data.animation, true),
          html: Utils.toBoolean(data.html, false),
          container: modal ? '.modal-content' : false,
          offset: data.offset || 0,
          placement: data.placement || 'top',
          boundary: data.boundary || 'window',
          title: data.content || data.title || $obj.attr('title') || '',
          trigger: data.trigger || 'hover focus',
          delay: data.trigger === 'click' ? 0 : delay,
        })
        .on('inserted.bs.tooltip', () => {
          const $tip = $($obj.data('bs.tooltip').tip);
          if (!arrow) $tip.addClass(`no-arrow`);
          if (color) $tip.addClass(`tooltip-${color}`);
        });
    });

    return this;
  },

  hide() {
    this.find('[data-tooltip]').each(function () {
      const $obj = $(this);
      const $tip = $($obj.data('bs.tooltip').tip);
      if ($tip.is('.show')) $obj.tooltip('hide');
    });

    return this;
  },
});
